import {Box, Divider, Stack, useMediaQuery, useTheme} from '@mui/material';
import React from 'react';
import {useBoundingclientrectRef} from 'rooks';
import googleLogo from '../assets/google.png';
import linkedinLogo from '../assets/linkedin.png';
import {useAuth} from '../providers/auth';
import * as Yup from 'yup';
import {useFormik} from 'formik';
import {AuthButton} from '../components/Auth/AuthButton';
import {AuthContainer} from '../components/Auth/AuthContainer';
import {AuthPaper} from '../components/Auth/AuthPaper';
import {AuthDrawer} from '../components/Auth/AuthDrawer';
import {Heading} from '../components/Auth/Heading';
import {TextInput} from '../components/Auth/TextInput';
import {Puller} from '../components/Auth/Puller';
import {HelperText} from '../components/Auth/HelperText';
import {HelperLink} from '../components/Auth/HelperLink';

function LoginContentBottom() {
  const {login, isLoading} = useAuth();
  return (
    <>
      <Stack spacing={3}>
        <AuthButton disabled={isLoading} onClick={() => login('google')}>
          <Box sx={{mr: 1, mb: '-4px'}} component="img" src={googleLogo} alt="Google" />
          Sign in with Google
        </AuthButton>
        <AuthButton disabled={isLoading} onClick={() => login('linkedin')}>
          <Box sx={{mr: 1, mb: '-3px'}} component="img" src={linkedinLogo} alt="Linkedin" />
          Sign in with Linkedin
        </AuthButton>
      </Stack>
      <Stack spacing={1} sx={{mt: 3}}>
        <HelperText>
          Having problems signing up? <HelperLink>Contact us</HelperLink>
        </HelperText>
        <HelperLink>Terms of service</HelperLink>
      </Stack>
    </>
  );
}

const loginSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
});

function LoginContentTop() {
  const {login, isLoading} = useAuth();
  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: loginSchema,
    onSubmit: values => {
      login('passwordless', values.email);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <Stack sx={{mt: 3}} spacing={3}>
        <TextInput
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          type="email"
          name="email"
          label="Email"
          variant="outlined"
          size="small"
          fullWidth
          disabled={isLoading}
          error={!!(formik.errors.email && formik.touched.email)}
        />
        <AuthButton primary disabled={isLoading} type="submit">
          Sign in
        </AuthButton>
      </Stack>
    </form>
  );
}

function Auth() {
  const theme = useTheme();
  const isBigScreen = useMediaQuery(theme.breakpoints.up('md'));
  const [myRef, boundingClientRect] = useBoundingclientrectRef();

  return (
    <AuthContainer>
      <Heading sx={{mb: '80px'}}>Welcome to GVMO Live</Heading>
      {isBigScreen && (
        <AuthPaper sx={{maxWidth: '488px', width: '100%', mx: 'auto'}}>
          <LoginContentTop />
          <Box sx={{my: 4}}>
            <Divider>or</Divider>
          </Box>
          <LoginContentBottom />
        </AuthPaper>
      )}
      {!isBigScreen && (
        <AuthDrawer>
          <AuthPaper sx={{borderRadius: 0, borderTop: 0, position: 'relative'}}>
            <AuthPaper
              ref={myRef}
              sx={{
                position: 'absolute',
                top: `-${boundingClientRect?.height ?? 0}px`,
                visibility: 'visible',
                right: `-1px`,
                left: `-1px`,
                borderBottom: 0,
                backdropFilter: 'none',
              }}
            >
              {!isBigScreen && <Puller />}
              <LoginContentTop />
            </AuthPaper>
            <Box sx={{mb: 4}}>
              <Divider>or</Divider>
            </Box>
            <LoginContentBottom />
          </AuthPaper>
        </AuthDrawer>
      )}
    </AuthContainer>
  );
}

export default Auth;
